<template>
    <b-card no-body  class="col-12 col-md-12">

        <b-modal size="lg" v-bind:hide-footer="true" id="detail" :title="announcementDetail.AnnouncementGroup +': ' +announcementDetail.Subject + ' - '+announcementDetail.CreateTime " no-close-on-esc no-close-on-backdrop>
            <announcement-detail v-model="announcementDetail"></announcement-detail>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    search
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { AnnouncementApi } from '@/api/announcement'
import AnnouncementDetail from './components/AnnouncementDetail.vue'
export default {
    components:{
        BCard,
        AnnouncementDetail
    },
    data(){
        return{
            fields:[
                {name:'Durum',key:'IsRead',sortable:true, thClass:'w-10'},
                {name:'Oluşturulma Zamanı',key:'CreateTime',sortable:true,sortKey:'Announcement.CreateTime',thClass:'w-30'},
                {name:'Grup',key:'AnnouncementGroup',sortable:true,sortKey:'Announcement.AnnouncementGroup',thClass:'w-30'},
                {name:'Konu',key:'Subject',sortKey:'Announcement.Subject',sortable:true, thClass:'w-30'},
                
            ],
            buttons:[
                { text:"Detay Görüntüle",key:"detail",icon:"EyeIcon",variant:"secondary",action:this.detail },
            ],
            announcementDetail:{
                Id:null,
                Subject: null,
                Content: null,
                CreateTime: null,
                AnnouncementGroup: null
            }
        }
    },
    methods:{
        clearForm(){
            this.announcementDetail.Id = null
            this.announcementDetail.Subject = null
            this.announcementDetail.Content = null
            this.announcementDetail.CreateTime = null
            this.announcementDetail.AnnouncementGroup = null
            
        },
        provider(data){
            return AnnouncementApi.Table(data)
        },
       
        edit(item){
            this.clearForm()
            this.announcementDetail.Id = item.Id
            this.announcementDetail.Subject = item.Subject
            this.announcementDetail.Content = item.Content
            this.announcementDetail.CreateTime = item.CreateTime
            this.announcementDetail.AnnouncementGroup = item.AnnouncementGroup
            this.$showModal('detail')
        },
        detail(item){
            this.$refs.table.rowLoading(true)
            AnnouncementApi.Detail(item.Id).then(res=>{
                this.$refs.table.rowLoading(false)
                if(res.data.Success){
                    this.edit(res.data.Data)
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.$refs.table.rowLoading(false)
                this.$result(null,err)
            })
        },
        
    }
}
</script>

<style>

</style>